import React, { FC } from 'react';
import css from '../../TemplatesMainPage.scss';
import { Text } from '@wix/design-system';
import { DataHooks } from '../../../../constants/dataHooks';
import { Trans, useTranslation } from '@wix/wix-i18n-config';

export const HeadingSection: FC = () => {
  const { t } = useTranslation();

  return (
    <div className={css.pageHeader}>
      <div className={css.headerLayout}>
        <Text
          dataHook={DataHooks.MainPagePriorTitle}
          className={css.headerPriorTitleText}
        >
          {t('app.main-page.prior.title')}
        </Text>
        <div className={css.headingWrapper}>
          <Text
            dataHook={DataHooks.MainPageTitle}
            weight="thin"
            className={css.headerTitleText}
          >
            <Trans i18nKey="app.main-page.title" components={[<br />]} />
          </Text>
          <Text
            dataHook={DataHooks.MainPageHeaderDescription}
            className={css.rightSideMainCardText}
          >
            {t('app.main-page.main.header.description')}
          </Text>
        </div>
      </div>
    </div>
  );
};
